import 'angular-timeago';

export default 'yaru22.angular-timeago';
